export default __webpack_public_path__ + "static/media/photo-1.16602b61.jpg";